import React from "react";
import { ResourceAvatar } from "@common/resourceAvatar";

import { Props } from "./types";
import styles from "./styles.scss";

function AllocationsList({ allocations }: Props) {
  return (
    <div className={styles.allocationsList}>
      {allocations.map((allocation) => (
        <div className={styles.allocation} key={allocation.uuid}>
          <ResourceAvatar resource={allocation.resource} />
        </div>
      ))}
    </div>
  );
}

export { AllocationsList };
